// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-6m-6","notFoundPage":"styles_notFoundPage__UH2Of"};